<div class="row">

    <div class="column" *ngFor="let ars of assets">
        <div class="blur-load" *ngFor="let img of ars" [style.background-image]="(img.low_quality) ? img.low_quality : ''">
            <img src="{{img.high_quality}}" alt=""  loading="lazy">
        </div>
    </div>

</div>
